import { RadarFigure } from "./RadarFigure";
import { ELEMENTS, type FiveStructures } from "./types";

const capitalised = (word: string) => `${word[0]!.toUpperCase()}${word.slice(1)}`;
const ORDERED_NAMES = ["Wealth", "Influence", "Resource", "Companion", "Output"];

export function FiveStructuresSection({ data }: { data: FiveStructures }) {
  return (
    <section className="bazi-section">
      <h3>Five Structures</h3>
      <div className="bazi-side-by-side">
        <div className="bazi-scroll">
          <table className="bazi-table" aria-label="Five Structures">
            <thead>
              <tr>
                <th rowSpan={2} scope="col" />
                {["Hour", "Day", "Month", "Year"].map((name) => (
                  <th key={name} colSpan={2} scope="colgroup">
                    {name}
                  </th>
                ))}
                <th colSpan={2} scope="colgroup">Composition</th>
                <th colSpan={3} scope="colgroup">Predominant</th>
              </tr>
              <tr>
                {[0, 1, 2, 3].flatMap((i) => [
                  <th key={`hs${i}`} scope="col">HS</th>,
                  <th key={`eb${i}`} scope="col">EB</th>,
                ])}
                <th scope="col">Abs</th>
                <th scope="col">%</th>
                <th scope="col" />
                <th scope="col">Abs</th>
                <th scope="col">%</th>
              </tr>
            </thead>
            <tbody>
              {ELEMENTS.map((element) => {
                const row = data[element];
                return (
                  <tr key={element}>
                    <th scope="row">{`${capitalised(element)} - ${row.dmElement}`}</th>
                    <td>{row.hourPillar.hs}</td>
                    <td>{row.hourPillar.eb}</td>
                    <td>{row.dayPillar.hs}</td>
                    <td>{row.dayPillar.eb}</td>
                    <td>{row.monthPillar.hs}</td>
                    <td>{row.monthPillar.eb}</td>
                    <td>{row.yearPillar.hs}</td>
                    <td>{row.yearPillar.eb}</td>
                    <td>{row.composition}</td>
                    <td>{row.compositionPercentage} %</td>
                    <td>{row.seasonWeight}</td>
                    <td>{row.predominant}</td>
                    <td>{row.predominantPercentage} %</td>
                  </tr>
                );
              })}
              <tr>
                <th scope="row" colSpan={9} />
                <td>{data.totalComposition}</td>
                <td>100%</td>
                <td />
                <td>{data.totalPredominant}</td>
                <td>100%</td>
              </tr>
            </tbody>
          </table>
        </div>
        <RadarFigure label="Five Structures chart" series="Five Structures" labels={ORDERED_NAMES} data={data.chartData} />
      </div>
    </section>
  );
}
